<template>
    <label>
        <Select v-model="currValue" ref="select" clearable :placeholder="placeholder" @on-change="selectChange" style="width: 200px;">
            <Option v-for="item in list" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
    </label>
</template>

<script>
    import iExam from "@/module/main/api/iExam";

    export default {
        name: "tester-sel",
        props: {
            value: {
                type: Number,
                default: 0
            },
            placeholder: {
                type: String,
                default: '请选择检测人员'
            },
            departmentId: {
                type: Number,
                default: 0
            },
            withoutDepart:{
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                currValue: this.value,
                list: [],
            }
        },
        mounted() {
            this.dataInit();
        },
        methods: {
            dataInit() {
                if (this.withoutDepart) {
                    iExam.testerList(null).then(res => {
                        this.list = res
                    });
                    return;
                }
                if (!this.departmentId) {
                    return;
                }
                iExam.testerList(this.departmentId).then(res => {
                    this.list = res
                });
            },
            selectChange(val) {
                val = val === undefined ? null : val;
                this.currValue = val;
                if (val !== this.value) {
                    this.$emit('input', val);
                    this.$emit('on-change', val);
                }
            }
        },
        watch: {
            value(val) {
                val = val === undefined ? null : val;
                if (val !== this.currValue) {
                    this.currValue = val;
                }
            },
            departmentId(val) {
                this.dataInit()
            }
        }
    }
</script>
